import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

interface CheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: string;
  description?: string;
  id?: string;
  required?: boolean;
  variant?: 'default' | 'consent';
}

export default function Checkbox({
  checked,
  onCheckedChange,
  label,
  description,
  id,
  required,
  variant = 'default',
}: CheckboxProps) {
  return (
    <label className={`cb-label${variant === 'consent' ? ' cb-label--consent' : ''}`}>
      <CheckboxPrimitive.Root
        className="cb-root"
        checked={checked}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        id={id}
        required={required}
      >
        <CheckboxPrimitive.Indicator className="cb-indicator">
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
            <path
              d="M13.5 4.5L6.5 11.5L2.5 7.5"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <span className="cb-text">
        <span className="cb-text__label">
          {label}
          {required && <span className="required" aria-label="required"> *</span>}
        </span>
        {description && <span className="cb-text__desc">{description}</span>}
      </span>
    </label>
  );
}
